// src/modules/app-views/_apps/appmulti/plans/pages/Init/components/PlansPreviewBody/index.jsx
// *******************************************************************************
// PLANS PREVIEW BODY
// *******************************************************************************
// Body component for the list preview drawer.
// Header (PlansPreviewHeader) handles: operator, name, price, coverages count, tags.
// Body handles: collapsible coverages detail list.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Collapse, theme, Typography } from 'antd';
import { UnorderedListOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// GLOBAL VARIABLES
// *******************************************************************************
const labelStyle = { display: 'inline-flex', alignItems: 'center', gap: 8 };
const textStyle = { fontSize: 13 };
const collapseStyle = { paddingLeft: 0 };
const collapseStyles = { header: { padding: '4px 0' } };
const rowStyle = (isLast, borderColor) => ({
  padding: '6px 0',
  borderBottom: isLast ? 'none' : `1px solid ${borderColor}`,
});

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const PlansPreviewBody = ({ selectedDocument: r }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { token } = theme.useToken();

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (!r) return null;

  const coverages = r?.coverages || [];

  if (coverages.length === 0) return null;

  const collapseItems = [
    {
      key: 'coverages',
      label: (
        <span style={labelStyle}>
          <UnorderedListOutlined />
          {translateX('coverages')} ({coverages.length})
        </span>
      ),
      children: (
        <div>
          {coverages.map((c, index) => (
            <div
              key={c._id || c.key || index}
              style={rowStyle(index === coverages.length - 1, token.colorBorderSecondary)}
            >
              <Text style={textStyle}>
                {translateX(c.coverageKey) || `#${index + 1}`}
              </Text>
            </div>
          ))}
        </div>
      ),
    },
  ];

  return (
    <Collapse
      ghost
      items={collapseItems}
      size="small"
      style={collapseStyle}
      styles={collapseStyles}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default PlansPreviewBody;
